import { NotFound, ProtectedRoute } from "@fdoh/health-ui-react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import InspectionHomePage from "../InspectionHome/InspectionHome";
import CreateDrainfieldInstallationPage, { UserManagementPage } from "./UserManagementForm";
//import EditDrainfieldInstallationPage from "./EditDrainfieldInstallationInspectionForm";
import HomePage from "../Home/Home";
import SupportRequestPage from "./UserManagementForm";


export const UserManagementModule = () => {
  let { path } = useRouteMatch();

  return (
    
      <Switch>
          <ProtectedRoute exact path={path}>
              <UserManagementPage />
          </ProtectedRoute>
         
             
        <Route>
          <NotFound />
        </Route>
      </Switch>
    
  );
};

export default UserManagementModule;
